import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './MFIInvestment.css';
import OtherMarketOption from "../../OtherMarketOption/OtherMarketOption";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function MFIInvestment() {
    const [data, setData] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);

        const getUrl = BaseURL + "OtherMarkets";
        fetch(`${getUrl}/MFI/20`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
                setloadingshow(false);

            })
            .catch((error) => {
            });



    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    
    CallTrackApi("MF Investment",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>MF Investment</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='MFI-loser-sc'>
                            <div className='MFI-header'>
                                <h2><span>MFI Investment</span></h2>
                            </div>
                            <OtherMarketOption optionOtherMarket="MF Investment" />

                            <hr></hr>
                            <div className='MFI-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className='text-left'>As on Date</th>
                                            <th className='text-left'>Equity / Debt</th>
                                            <th className='text-right'>Gross Purchase(Rs)</th>
                                            <th className='text-right'>Gross Sale(Rs)</th>
                                            <th className='text-right'>Net Purchase(Rs)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ TRANS_DATE, EQ_GR_PURC, EQ_GR_SALE, EQ_G_NE_PS, DE_GR_PURC, DE_GR_SALE, DB_G_NE_PS }) => (
                                                <>
                                                    <tr>
                                                        <td className="text-left">{(TRANS_DATE != null) ? TRANS_DATE.split('T')[0] : 0}  </td>
                                                        <td className="text-left">Equity</td>
                                                        <td className="text-right">{EQ_GR_PURC}</td>
                                                        <td className="text-right">{EQ_GR_SALE}</td>
                                                        <td className="text-right">{EQ_G_NE_PS}</td>
                                                    </tr>

                                                    <tr>
                                                        <td></td>
                                                        <td className="text-left">Debt</td>
                                                        <td className="text-right">{DE_GR_PURC}</td>
                                                        <td className="text-right">{DE_GR_SALE}</td>
                                                        <td className="text-right">{DB_G_NE_PS}</td>
                                                    </tr>


                                                </>
                                            ))}

                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MFIInvestment;